import router from '../../router/index'
import axios from 'axios';

//************************URLS**********************************************

/*const baseURL = "https://servintp.latinoseguros.com.mx:8091/"; // Producción
const urlPago = baseURL + "sites/cobrolinea/common/bancos.aspx";
const urlBanRegio = baseURL + "sites/cobrolinea/BanRegio/MasivoPagoBanRegio.aspx"*/

const baseURL = "https://servintp.latinoseguros.com.mx:8091/"; // Pruebas
const urlPago = baseURL + "sites/cobrolinea/common/bancos.aspx";
const urlBanRegio = baseURL + "sites/cobrolinea/BanRegio/MasivoPagoBanRegio.aspx"
const baseURLAPEMantto = "https://servintp.latinoseguros.com.mx:8091/";

//const baseURLAPEMantto = "https://servintd.latinoseguros.com.mx:8070/";//DEV


//************************USUARIOS*******************************************
/*export function getSubscriptionRoleId() {
  return '40150'
}*/ // Para TEST / DEV:

export function getSubscriptionRoleId() {
  return '20159'}   // Para PRODUCCIÓN:


export const pago = () => urlPago;

export const axiosBaseUrl = () => baseURL; 

export const axiosUrlBanRegio = () => urlBanRegio;

export const axiosBaseURLAPEMantto = () => baseURLAPEMantto;

axios.defaults.baseURL = baseURL;
    

export const login = (context, data) => {
    const { usuario, redir } = data;
    context.commit('loginStart')
    try {
        const config = {
            method: 'post',
            url: 'security/api/LoginVue',
            headers: {
                'Content-Type': 'application/json',
                // 'XAPPID': 'F827FE82207B214D85FB0C8856B1BCB411D4'
            },
            data: JSON.stringify(usuario)
        };
        axios(config)
            .then(function(response) {
                if (response.status === 200) {
                    if (response.data.flag) {
                        context.commit('setToken', response.data.data.tokenId)
                        localStorage.setItem('token', response.data.data.tokenId)
                        localStorage.setItem('profileId', response.data.data.profileId)
                        localStorage.setItem('userId', response.data.data.userId)
                        localStorage.setItem('urlPago', urlPago)
                        !redir ? 
                            router.push('/demo/api')
                        : null;
                    } else {
                        // console.log(response.data.data.errorMessage);
                    }
                    // eslint-disable-next-line no-empty
                } else {

                }
                context.commit('loginStop', null)
            })
            .catch(function(error) {
                context.commit('loginStop', error)
            });
    } catch (error) {
        context.commit('loginStop', error)
    }
}

export const getToken = (context) => {
    if (localStorage.getItem('token')) {
        context.commit('setToken', localStorage.getItem('token'))
    } else {
        context.commit('setToken', null)
    }
}

export const logOut = (context) => {
    context.commit('setToken', null)
    localStorage.removeItem('token')
    localStorage.removeItem('profileId')
    router.push('/')
}

export const getTipoCambio = () => {

}

export const enableLoading = (context) => {
    context.commit('showLoading')
}

export const disabledLoading = (context) => {
    context.commit('hideLoading')
}

export const metodoPost = (context, params) => {
    try {

        context.commit('showLoading')
        context.commit('setLimpiadataResponse')
        getToken(context)
        context.commit('getRutas', params)
        return new Promise((resolve, reject) => {
            axios(context.state.config)
                .then(function(response) {
                    context.commit('setDataRaw', response.data)
                    if (response.status === 200) {
                        context.commit('setDataResponse', response.data.data)
                        context.commit('setDataRaw', response.data)

                        if (response.data.flag) {
                           
                        //resolve(response.data.flag) 
                        resolve(response.data)  //Comentar si se rompe algo y dejar la anterior 
                        } else {
                            // var Modal = {
                            //     muestra: true,
                            //     color: "danger",
                            //     contenido: response.data.errorMessage,
                            //     boton: "Aceptar",
                            //     titulo: "Error al ejecutar " + response.config.url.split('/')[response.config.url.split('/').length - 1]
                            // }

                            // context.commit('showModal', Modal)
                            
                            //resolve(response.data.flag)
                            resolve(response.data)  //Comentar si se rompe algo y dejar la anterior 
                           
                        }
                        context.commit('setFlagResponse', response.data.flag)

                    } else {
                        context.commit('setFlagResponse', false)

                    }
                    context.commit('hideLoading');


                })


            .catch(function(error) {
                var Modal = {
                    muestra: true,
                    color: "danger",
                    contenido: "Algo salió mal",
                    boton: "Aceptar",
                    titulo: "Error"
                }

                // context.commit('showModal', Modal)
                context.commit('hideLoading');
                reject()
            });

        })

    } catch (error) {
        // commit('loginStop', error)
    }
}



export const metodoPostOutLoading = (context, params) => {
    try {
        //context.commit('showLoading')
        context.commit('setLimpiadataResponse')
        getToken(context)
        context.commit('getRutas', params)
        return new Promise((resolve, reject) => {
            axios(context.state.config)
                .then(function(response) {
                    context.commit('setDataRaw', response.data)
                    if (response.status === 200) {
                        context.commit('setDataResponse', response.data.data)
                        context.commit('setDataRaw', response.data)

                        if (response.data.flag) {
                            resolve(response.data.flag)
                        } 
                        else {
                            resolve(response.data.flag)
                        }
                        context.commit('setFlagResponse', response.data.flag)

                    } else {
                        context.commit('setFlagResponse', false)

                    }
                    //context.commit('hideLoading');
                })
            .catch(function(error) {
                var Modal = {
                    muestra: true,
                    color: "danger",
                    contenido: "Algo salió mal",
                    boton: "Aceptar",
                    titulo: "Error"
                }

                // context.commit('showModal', Modal)
                context.commit('hideLoading');
                reject()
            });
        })
    } catch (error) {
        // commit('loginStop', error)
    }
}

export const hideLoadingStore = (context) => {
    try {
        //context.commit('showLoading')
        context.commit('hideLoading');
        //reject();
    } catch (error) {
        // commit('loginStop', error)
    }
}